export default "__VITE_ASSET__DpYxMQKA__"